import React, {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux';
import {useLocation} from 'react-router-dom';
import queryString from 'query-string';

import LoadingDisplay from '@nhl/nhl-react-ui/lib/LoadingDisplay';
import {hockeyFormatter} from '@nhl/formatter-utilities';

import ComponentSeasonIdentifiers from '../../utils/componentSeasonIdentifiers';

import {teamsOperations} from '../../redux/ducks/teams/index';
import {ACTIVE_SEASON_IDENTIFIER} from '../../redux/ducks/teams/reducers';

const league = 'NHL';

const withTeams = (WrappedComponent, withActiveTeams = false, componentSeasonId = ComponentSeasonIdentifiers.GAMES, withStats = true) => {
    return (props) => {
        const dispatch = useDispatch();
        const location = useLocation();
        const query = queryString.parse(location.search);

        const availableTeams = useSelector(({teams}) => teams.teamsState.availableTeams);
        const componentSeasons = useSelector(
            ({componentSeason}) => componentSeason.componentSeasonsState.componentSeasons);

        let season;
        if (withActiveTeams) {
            season = ACTIVE_SEASON_IDENTIFIER;
        } else {
            if (query.season && query.season !== 'all') {
                season = query.season;
            } else if (componentSeasons.length > 0) {
                season = componentSeasons.find(season => season.id === componentSeasonId).season;
            } else {
                season = hockeyFormatter.getCurrentApproximateSeason();
            }
            season = parseFloat(season);
        }

        useEffect(() => {
            if (!availableTeams[season]) {
                if (withActiveTeams && !withStats) {
                    dispatch(teamsOperations.fetchActiveNHLTeams());
                } else {
                    dispatch(teamsOperations.fetchTeamsForLeagueAndSeason(season, league));
                }
            }
        }, [availableTeams, season, league, withActiveTeams]);

        const teams = availableTeams[season];
        if (teams && Object.keys(teams).length > 0) {
            return <WrappedComponent {...props} teams={teams}/>;
        }
        return <div className="dummy-container"><LoadingDisplay isLoading={true}/></div>;
    };
};

export default withTeams;
